<template>
  <div>
    <b-table :items="data" :fields="fields"> 
      <template #cell(WINNINGS)="row">
        <template v-if="row.item.WINNINGS == '0.00'">

        </template>
        <template v-else>
          {{ row.item.CURRENCY_SIGN }} {{ row.item.WINNINGS }}
        </template>
      </template>
      <template #cell(POSITION)="row">
        {{ row.item.POSITION }} <span v-if="row.item.POSITION == '1'"> <b-img class='trophy' :src="config.VUE_APP_WP_DIGITAL_OCEAN+'2019/07/TROPHY.png'"></b-img></span>
      </template>
      </b-table>
  </div>
</template>

<script>
export default {
  name: "playerresults",
  props: ['data', 'config'],
  data() {
    return {
      noEntry: "noEntry",
      fields: [
        { key: "DATE", label: "Date", class: 'center' },
        { key: "NAME", label: "Name" },
        { key: "POSITION", label: "Pos" },
        { key: "ROUNDS", label: "Rounds", class:"hideclass"  },
        { key: "SCORE", label: "Total", class:"hideclass" },
        { key: "WINNINGS", label: "Winnings", class:"winningColors" }
      ]
    };
  },
};
</script>

<style scoped>
::v-deep td.winningColors {
  color: #003C52!important;
}
.noEntry {
  display: none;
}
::v-deep table>thead>tr>th{
  background-color: #003C52;
  padding: 16px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  padding-left: 0;
  /* border-right: 1px solid black; */
}
::v-deep th.center {
    text-align: center !important;
}
::v-deep td.center {
    text-align: center !important;
}
::v-deep table>tbody>tr>td{
  text-align: left;
  padding: 5px;
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #f9f9f9!important;
  line-height: 22px;
  min-height: 38px;
  color: black;
  font-weight: 700;
  border-top: 1px solid #d9d9d8;
  font-size: 14px;
  white-space: nowrap;
  width: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.trophy{
  width: 15px;
}
@media screen and (max-width: 768px) {
  ::v-deep th.hideclass {
    display: none;
  }
    ::v-deep td.hideclass {
    display: none;
  }
}
</style>
